import { doRequest } from '../../api/index';
import setupInterceptors from '../../api/interceptors';

const state = {
  info: {},
  token: ''
};

const getters = {
  user(s) {
    return s.info;
  },
  token(s) {
    return s.token
  }
};

const actions = {
  login({ commit }, args) {
    return doRequest('auth.login', args)
      .then((data) => {
        commit('setToken', data);
        setupInterceptors();
        return data;
      });
  },
  userInfo({ commit }, args) {
    return doRequest('auth.userInfo', args)
      .then((data) => {
        commit('setInfo', data);
        return data;
      });
  },
  forgotPassword({ commit }, args) {
    return doRequest('auth.forgotPassword', args);
  },
  resetPassword({ commit }, args) {
    return doRequest('auth.resetPassword', args);
  },
  registerUser({ commit }, args) {
    return doRequest('auth.registerUser', args);
  },
  changePassword({ commit }, args) {
    return doRequest('user.changePassword', args);
  },
  editUserProfile({ commit }, args) {
    return doRequest('user.updateProfile', args);
  }
};

const mutations = {
  setToken(s, data) {
    s.token = data.access_token;
  },
  setInfo(s, userInfo) {
    s.info = userInfo;
  }
};


export default {
  state,
  getters,
  actions,
  mutations,
};
